import React from "react";
import { Checkbox, FormControlLabel } from "@mui/material";
import { Control, Controller } from "react-hook-form";

interface Props {
  control: Control<any, any>;
  fieldName: string;
  label: string;
  required?: boolean;
  disabled?: boolean;
}

const FormCheckbox: React.FC<Props> = (props) => {
  const { control, fieldName, label, required, disabled } = props;

  return (
    <Controller
      name={fieldName}
      control={control}
      rules={{ required: required }}
      render={({ field }) => (
        <FormControlLabel
          disabled={disabled}
          control={<Checkbox checked={field.value} />}
          label={label}
          {...field}
        />
      )}
    />
  );
};

export default FormCheckbox;
